var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pcnewddetails"},[_c('el-backtop'),_c('div',{},[_c('headers',{ref:"head",on:{"ChangeEmit":_vm.ChangeEmit}})],1),_c('div',{staticClass:"newclassf",domProps:{"innerHTML":_vm._s(_vm.newcontent)}}),_c('footers',{ref:"is_change"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }